import { useMemo } from "react";

import useActivationQueryWithAccessControl from "app/custom-hooks/activation/useActivationQueryWithAccessControl";

export const useExistingProjects = () => {
    const { data: existingProjects = [] } = useActivationQueryWithAccessControl();
    const existingNames = useMemo(() => existingProjects.map(({ name }) => name), [existingProjects]);

    return { existingNames, existingProjects };
};
